import React from 'react';
import { Card, Col, Spinner } from 'react-bootstrap';
import "./style.scss"

export default function CardValue({title, value, load, md}){
  return (
    <Col md={md} className="p-1 h-100">
      <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100 card-value">
        <label>
          {title}
        </label>
        <label>
          {load ? (
            <Spinner animation="border" size="sm" />
          ) : value}
        </label>
      </Card.Body>
    </Col>
  )
}